<template>
    <div class="index">
        <div style="width: 1200px; margin: 0 auto;">
            <div class="top_title">
                <!-- 左侧位置 -->
                <div class="top_title_left">
                    <div class="left_icon">
                        <img src="../../assets/xiangning/news_detail/location.png" alt="">
                    </div>
                    <div class="left_text">
                        当前位置：三会一课>详情
                    </div>
                </div>
                <div class="right_back">
                    <div class="right_back_icon"><img src="../../assets/xiangning/news_detail/back.png" alt=""></div>
                    <div @click="$router.go(-1)">返回</div>
                </div>
            </div>
            <!-- 文章内容 -->
            <div class="artical_content" style="margin-bottom: 40px;">
                <!-- 上方文章标题 -->
                <div class="artical_content_title">
                    <div class="artical_content_title_main">
                        {{ title }}
                    </div>
                    <!-- 发布时间及来源 -->
                    <div class="artical_content_title_time">
                        <!-- <span>2022-08-09</span> -->
                        <!-- <span>来源：人民网</span> -->
                    </div>
                    <!-- 调整字号大小 -->
                    <div v-if="false" class="changeFontSize">
                        <span>字号调节：</span>
                        <!-- 字号变大 -->
                        <div @click="changeFontSize('add')" class="changeFontSize_A"><img
                                src="../../assets/xiangning/news_detail/fontAdd.png" alt=""></div>
                        <!-- 字号变小 -->
                        <div @click="changeFontSize('red')" class="changeFontSize_A"><img
                                src="../../assets/xiangning/news_detail/fontR.png" alt=""></div>
                    </div>
                </div>
                <div class="rsd_video_play">
                    <div class="rsd_video_play_left_video">
                        <video v-if="bs_id == 3" @contextmenu.prevent width="100%" height="100%" controlslist="nodownload"
                            id="my-video" style="background-color: #000000;" class="left" controls preload
                            autoplay="autoplay" :src="kcSrc">
                            <source type='video/mp4'>
                        </video>
                        <iframe style="width: 100%;height: 100%; position: absolute; " v-if="bs_id == 1"
                            :src="http + '//vip.ow365.cn/?i=33543&ssl=1&furl=' + kcSrc"
                            frameborder="0"></iframe>
                        <!-- <iframe style="width: 100%;height: 115%; position: absolute; top: -80px;"
                            v-if="bs_id == 1"
                            :src="'./pptxPlay.html?pptxUrl='+kcSrc"
                              frameborder="0">
                        </iframe> -->
                        <pdfView id="con_lf_top_div" :pdfUrl="kcSrc" v-if="bs_id == 8"></pdfView>
                        <div class="screenFull" v-if="bs_id == 8" @click="$screen(false)">pdf全屏预览（F11）退出</div>
                        <img style="width: 100%;overflow-y: auto;" v-if="bs_id == 2" :src="kcSrc" alt="">
                    </div>
                    <div class="rsd_video_play_right_list">
                        <div class="rsd_video_play_right_list_top">
                            <div style="color:#fff;borderBottom: 1px solid #C51212;text-align: center;"
                                class="rsd_video_play_right_list_top_item">课程目录
                            </div>
                        </div>
                        <div class="rsd_video_play_right_title_box">
                            <!-- 标题列表 -->
                            <div @click="changeTitle(item)"
                                :style="{ backgroundColor: selectTitleId == item.id ? '#1E1E1E' : '' }"
                                class="rsd_video_play_right_title" v-for="item in resouce">
                                <div :style="{ color: selectTitleId == item.id ? '#FFE74A' : '' }"
                                    class="rsd_video_play_right_title_item">
                                    {{ item.title }}
                                </div>
                            </div>
                           
                        </div>

                        <div v-if="false" class="rsd_video_play_right_content_bottom">
                            <div class="rsd_video_play_right_content_bottom_item">
                                <span>
                                    <img v-if="false" src="../../assets/xiangning/icon/shoucang.png" alt="">
                                    <img v-if="true" src="../../assets/xiangning/icon/shoucang-yishoucang.png" alt="">
                                </span>
                                资源收藏
                            </div>
                            <!-- <div   class="rsd_video_play_right_content_bottom_item">
                                       <span>
                                            <img src="../../assets/xiangning/icon/sancode.png" alt="">
                                        </span>
                                        扫码带走
                            </div> -->
                            <div class="rsd_video_play_right_content_bottom_item">
                                <span>
                                    <img src="../../assets/xiangning/icon/download.png" alt="">
                                </span>
                                资源下载
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>
<script>
import { zzsh } from '@/axios'
import { RETURN } from 'core-js/modules/_for-of'
import pdfView from '@/components/pdfView.vue'
export default {
    data() {
        return {
            bs_id: '',
            title: '',
            kc_content: '',
            kcSrc: '',
            resouce: [],
            index: 0,
            // 字体大小,
            sizes: 14,
            seltecContent: 1,
            selectTitleId: 1,
            http: ''


        }
    },
    components: { pdfView },
    methods: {

        changeTitle(data) {
            this.selectTitleId = data.id
            this.bs_id = data.bsid
            this.kcSrc = data.src
        },
        handleScroll() {
            let that = this
            // 判断页面的滚动距离如果大于500展示回到顶部按钮
            if (window.pageYOffset > 500) {
                that.isShow = true
            } else {
                that.isShow = false
            }
        },
        toTopHandle() {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
        // 改变页面字体大小
        changeFontSize(val) {
            let that = this
            if (val == 'add') {
                // 加大字号
                that.sizes = that.sizes + 2
            } else {
                that.sizes = that.sizes - 2
            }

        },
        // 获取资源详情
        getResouceDetail() {
            let that = this
            zzsh.shykDetail({ id: that.$route.query.id, flag: this.$route.query.flag }).then(res => {
                if (res.code == 200) {

                    that.title = res.data.detail.title
                    that.bs_id = that.$route.query.bsid
                    that.resouce = res.data.detail.resouce
                    that.selectTitleId = this.$route.query.zyid

                    that.resouce.forEach(item => {
                        if (item.id == that.selectTitleId) {
                            that.kcSrc = item.src
                            console.log(that.kcSrc);

                        }
                    });
                }
            })

        },


    },
    mounted() {
        // 给页面添加滑动时间
        window.addEventListener("scroll", this.handleScroll);
        this.selectTitleId = this.$route.query.id
        this.getResouceDetail()
        if (location.protocol == 'http:') {
            this.http = 'http:'
        } else {
            this.http = 'https:'
        }

    },
    computed: {
        // 计算属性，返回当前是否应该显示返回顶部按钮
        shouldShowBackToTop() {
            return this.scrollY >= this.threshold; // 假设滚动距离超过 500px 时显示按钮
        }
    },
    created() {

    }
}
</script>

<style scoped>
.top_title {
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #D8D8D8;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.top_title_left {
    display: flex;
    align-items: center;
}

.left_icon {
    width: 20px;
    height: 20px;
    margin-right: 5px;
}

img {
    width: 100%;
    height: 100%;
}

.left_text {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #999999;
    height: 20px;
    line-height: 20px;
    background-color: #fff;
}

.right_back {
    display: flex;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
    margin-right: 10px;
}

.right_back:hover {
    font-weight: 800;
    color: #C9010A;
}

.right_back_icon {
    height: 10px;
    width: 12px;
    margin-right: 5px;
}

.right_back_icon img {
    height: 100%;
    width: 100%;
}

.artical_content {
    /* border-bottom: 1px solid #D8D8D8; */
}

.artical_content_title {
    margin-top: 30px;
    padding: 0 140px;
    position: relative;
}

.artical_content_title_main {
    width: 100%;
    white-space: wrap;
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 24px;
    font-weight: 800;
    text-align: center;
    letter-spacing: 0em;

    color: #000000;
    margin-bottom: 10px;
}

.artical_content_title_time {
    font-family: PingFangSC-Regular;
    text-align: center;
}

.artical_content_title_time span {
    margin-right: 10px;
    font-size: 14px;
    font-weight: normal;
    text-align: center;
    letter-spacing: 0em;

    color: #000000;
}

.backTop {
    width: 70px;
    height: 70px;
    position: fixed;
    top: 500px;
    right: 224px;
}

.backTop img {
    width: 70px;
    height: 70px;
}

.changeFontSize {
    z-index: 99;
    position: absolute;
    top: 3PX;
    right: 0;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #1C76FD;
    display: flex;
    align-items: center;
}

.changeFontSize_A {
    display: inline-block;
    width: 17px;
    height: 28px;
    margin-left: 10px;
}

.rsd_video_play {
    width: 100%;
    height: 535px;
    margin-top: 20px;
    display: flex;
    /* background-color: pink; */
}

.rsd_video_play_left_video {
    height: 100%;
    width: 880px;
    background-color: #555555;
    position: relative;
    overflow: hidden;
}

.rsd_video_play_right_list {
    width: 320px;
    height: 535px;
    background-color: #2D2D2D;

}

.rsd_video_play_right_list_top {
    width: 100%;
    height: 50px;
    border-bottom: 1px solid #1E1E1E;
    display: flex;
    justify-content: center;
    box-sizing: border-box;

}

.rsd_video_play_right_list_top_item {
    cursor: pointer;
    line-height: 50px;
    height: 100%;
    width: 60px;
    box-sizing: border-box;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #999999;
    /* width: 160px; */

}

.rsd_video_play_right_title_box {
    width: 100%;
    height: 400px;
    overflow-y: auto;
}

.rsd_video_play_right_title {
    width: 100%;
    height: 80px;
    box-sizing: border-box;
    padding: 20px 30px;
}

.rsd_video_play_right_title:hover {
    background-color: #1E1E1E;

}

.rsd_video_play_right_title:hover .rsd_video_play_right_title_item {
    color: #FFE74A;
}

.rsd_video_play_right_title_item {
    width: 100%;
    height: 100%;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: normal;
    letter-spacing: 0em;
    line-height: 20px;
    color: #FFF;
    overflow: hidden;
    text-overflow: ellipsis;
    /* 将对象作为弹性伸缩盒子模型显示 */
    display: -webkit-box;
    /* 限制在一个块元素显示的文本的行数 */
    /* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
    -webkit-line-clamp: 2;
    /* 设置或检索伸缩盒对象的子元素的排列方式 */
    -webkit-box-orient: vertical;
}

.rsd_video_play_right_content {
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 25px;
    font-weight: normal;
    text-align: justify;
    /* 浏览器可能不支持 */
    letter-spacing: 0em;
    color: #999999;
    text-indent: 28px;
    box-sizing: border-box;
    padding: 10px 15px;
    height: 400px;
    overflow: auto;

}

.rsd_video_play_right_content_bottom {
    width: 100%;
    height: 80px;
    /* background-color: skyblue; */
    box-sizing: border-box;
    padding: 0px 16px;
    display: flex;
    justify-content: space-between;
}

.rsd_video_play_right_content_bottom_item {
    margin-top: 20px;
    width: 88px;
    height: 32px;
    background-color: #1E1E1E;
    border-radius: 4px;
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #FFFFFF;
    line-height: 32px;
    text-align: center;
    display: flex;
    align-items: center;
}

.rsd_video_play_right_content_bottom_item span {
    /* display: inline-block; */
    width: 16px;
    height: 16px;
    margin-right: 5px;
    margin-left: 5px;
    line-height: 16px;
    margin-bottom: 2px;

}

.rsd_video_play_right_content_bottom_item span img {
    width: 100%;
    height: 100%;
}

.rsd_bottom_title {
    width: 100%;
    height: 40px;
    background-color: #F7F7F7;
    box-sizing: border-box;
    padding: 9px 6px;
    margin-top: 30px;
    margin-bottom: 30px;
}

.rsd_bottom_title_content {
    box-sizing: border-box;
    height: 22px;
    border-left: 4px solid #EE632B;
    display: flex;
    justify-content: space-between;

}

.rsd_bottom_title_content_left {
    height: 100%;
    padding-left: 10px;
    font-family: PingFang SC;
    font-size: 16px;
    font-weight: 800;
    letter-spacing: 0.1em;
    color: #000000;
    line-height: 22px;
}

.rsd_bottom_title_content_left_right {
    height: 22px;
    line-height: 22px;
    font-family: PingFang SC;
    font-size: 12px;
    font-weight: normal;
    letter-spacing: 0em;
    color: #666666;
}

.rsd_bottom_title_content_left_right span {
    display: inline-block;
    width: 15px;
    height: 12px;
}

.rsd_bottom_title_content_left_right span img {
    width: 100%;
    height: 100%;
}

.rsd_bottom_title_content_left_right:hover {
    color: #EE632B;
    cursor: pointer;
}

.rsd_bottom_content {
    width: 100%;
    display: flex;
    margin-bottom: 40px;
    flex-wrap: wrap;
}

.rsd_bottom_content_item {
    border-radius: 4px;
    overflow: hidden;
    width: 222px;
    height: 166px;
    border: 1px solid #ECEEF4;
    margin-right: 20px;
    margin-bottom: 20px;
    /* background-color: pink; */
}

.rsd_bottom_content_item:nth-child(5n) {
    margin-right: 0;
}

.rsd_bottom_content_item_top {
    width: 100%;
    height: 126px;
    /* background-color: skyblue; */
}

.rsd_bottom_content_item_top img {
    width: 100%;
    height: 100%;
}

.rsd_bottom_content_item_bottom {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 800;
    letter-spacing: 0em;
    color: #000000;
}
</style>
